import React from 'react';
import { Card } from '../components/ui/card';
import { Shield, Search, Award, FileCheck } from 'lucide-react';

export default function Authentication() {
  return (
    <div className="min-h-screen py-12">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="font-display text-3xl sm:text-4xl text-foreground font-semibold mb-4">Authentication Process</h1>
        <p className="text-muted-foreground mb-10">Every timepiece on V watch undergoes a rigorous multi-step authentication process before it can be listed.</p>

        <div className="space-y-6">
          {[
            { icon: Search, title: 'Visual Inspection', desc: 'Our certified horologists examine the case, dial, hands, bezel, and bracelet under 10x magnification. We verify engravings, serial numbers, and finishing quality against manufacturer specifications.' },
            { icon: FileCheck, title: 'Movement Verification', desc: 'The movement is inspected through the caseback or by opening the case. We verify the calibre reference, decoration, and components match genuine manufacturer standards. Timing accuracy is tested on a Witschi timing machine across multiple positions.' },
            { icon: Shield, title: 'Documentation Check', desc: 'Original papers, warranty cards, and certificates are verified against known templates. Serial numbers on documents are cross-referenced with the watch case. We check the dealer stamp, purchase date, and warranty validity.' },
            { icon: Award, title: 'Certificate of Authenticity', desc: 'Watches that pass all checks receive a V watch Certificate of Authenticity. This certificate includes high-resolution photographs, serial number verification, and condition assessment. It accompanies the watch through every transaction on our platform.' },
          ].map((step, i) => (
            <Card key={i} className="p-6 border-border bg-card">
              <div className="flex gap-4">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <step.icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Step {i + 1}: {step.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <Card className="p-6 border-border bg-card mt-10">
          <h3 className="font-semibold text-foreground mb-2">Our Guarantee</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">If a watch purchased through V watch is found to be inauthentic, we provide a full refund including all transaction fees. Our authentication guarantee covers you for the lifetime of the watch. Contact our team at support@vwatch.shop for any concerns.</p>
        </Card>
      </div>
    </div>
  );
}
